import { Types } from '@grandvisionhq/graphql';
import { DateUtils } from '@grandvisionhq/utils';

const getSubscriptionDetails = (cart)=>{
    const cartContainsContactLensesSubscriptionLineItems = cart.lineItems.filter((item)=>item.lineItemType === Types.LineItemType.BUNDLE
    ).some((item)=>item.bundleLineItemsType === Types.BundleLineItemType.CONTACT_LENSES_SUBSCRIPTION
    );
    if (!cartContainsContactLensesSubscriptionLineItems || !cart.subscriptionPlan || !cart.price.subscriptionPlanPrice) {
        return undefined;
    }
    const billingDate = new Date(cart.subscriptionPlan.billingDate);
    const subscriptionDetails = {
        billingDate: DateUtils.toLocalDate(billingDate),
        firstPayment: cart.price.subscriptionPlanPrice.invoicedAmount,
        recurringPayment: cart.price.subscriptionPlanPrice.total
    };
    return subscriptionDetails;
};

export { getSubscriptionDetails };
//# sourceMappingURL=get-subscription-details.js.map
